import { render } from "./ShowAllDepartment.vue?vue&type=template&id=85288c32"
import script from "./ShowAllDepartment.vue?vue&type=script&lang=js"
export * from "./ShowAllDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__